import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ComponentService } from '../../services/component.service';
import { Formulari, RentriService } from '../../services/rentri.service';
import { Utenteservice } from '../../services/utente.service';

@Component({
  selector: 'app-rentri',
  template: '',
  styleUrls: ['./rentri.component.css']
})



export class RentriComponent implements OnInit {
  

  infoAzienda: Object = [];
  showTab:boolean=false;
  isLogged:boolean=false
  denominazioneAzienda: any;
  queryParmas:any={}
  constructor(private rentriService: RentriService,private userComponentService : ComponentService, private router:Router,private utenteService: Utenteservice,private loader: NgxSpinnerService, private activateRoute:ActivatedRoute ) {}




  ngOnInit() {

    
    let rentriToken = sessionStorage.getItem('rentrisessiontoken');
    
    this.activateRoute.queryParams.subscribe(queryParams => {
      this.queryParmas =  queryParams 
      if(queryParams.data){
        const data = JSON.parse(queryParams.data);

        if(data.idSoggetto){
          this.loginRentriBySoggetto(data.idSoggetto)
        }
      }
    
    })
    return 
    
    if(rentriToken != '' && typeof this.utenteService.DammiToken() != 'undefined'  && this.isLogged){
      this.isLogged=true;
    }else{
      this.isLogged=false
      //this.router.navigateByUrl('/login-rentri')
    }
    //alert(rentriToken)
          
    

    
     
  
  }
  loginRentriBySoggetto(idSoggetto){
    this.loader.show();
   
      this.rentriService.loginRentriSoggetto(idSoggetto).then(response=> {
      
        if(response){
          this.isLogged=true;
          if(response){
        
            this.rentriService.getInfoAzienda().then(azienda=>{
             
              this.infoAzienda = azienda;
              this.denominazioneAzienda = this.clerAzienda(this.infoAzienda[0].denominazione)
              //this.setViewTab(this.infoAzienda[0])

             
               
              
              const navigationParams = {...this.queryParmas, 
                infoAzienda: JSON.stringify(this.infoAzienda[0]),
                componentTemplate:'griglia',
                denominazioneAzienda:this.denominazioneAzienda
              }
              //const navigationParams = {...this.queryParmas, infoAzienda: JSON.stringify(this.infoAzienda[0])}
             
              this.router.navigate(
                ['main/rentri-formulari'],
                {
                  queryParams: navigationParams,
                  skipLocationChange: true,
                  replaceUrl: false
                }
              ).then(re => {
                
              })
        

              this.showTab=true
              this.loader.hide();
            })
          }
        }
      })
   
    

  }


  setLoginInfo(dataUserInfo){

   

    let userInfo =[{
      codeMessage: 0,
      descrMessage: "",
      traceMessage: "",
      id: 10000,
      userName: dataUserInfo['userName'],
      nomeCompleto: dataUserInfo['nomeCompleto'],
      codiceFiscale: "",
      telefono: "",
      scadenzaPassword: "",
      foto: "",
      emailRecupero: "rentri@nica.it",
      emailComunicazioni: "rentri@nica.it",
      guidAccettazione: "",
      owner: false,
      sospeso: false,
      idtipoutente: 4,
      accessoConPIN: 0,
      aziendaSelected: 1,
      idAzienda: null
    }]
    this.utenteService.SetetUserInfo(userInfo);
    this.utenteService.AccessiExagerato.loggato = true;
  }

  setViewTab(infoAzienda){
    
      let tabsJson =[
        {
          id: 0,
          title: 'Formulari',
          icon: 'user',
          key:'form',
          component:'FormulariRentriComponent',
          data:[
            {
              infoAzienda : infoAzienda
            }
          ]
  
        },
        {
          id: 1,
          title: 'Movimenti',
          icon: 'move',
          key:'move',
          component:'MovimentiComponent',
          data:[
            {
              idDefaultUl:'REN0003-00006',
              
            }
          ]
          
  
        }
      ];
   
      this.userComponentService.setTabs("rentri",tabsJson);
     
  }
  clerAzienda(string){

    return string.replace(/[^\w\s]/gi,'')
  }

}